import './App.scss';
import Header from './components/Mainpage/Header';
import { Route, Routes, useLocation } from 'react-router-dom';
import 'react-medium-image-zoom/dist/styles.css';
import Home from './components/Content/Home';
import HotProducts from './components/Content/HotProducts';
import CategoryList from './components/Content/CategoryList';
import NewArrival from './components/Content/NewArrival';
import AlsoLike from './components/Content/AlsoLike';
import Landingpage from './components/Landingpage/Landingpage'
import Productshow from './components/Content/Productshow';
import Footer from './components/Footer/Footer';
import Showallreviews from './components/Content/Showallreviews';
import AboutUs from './components/Content/AboutUs';
import Search from './components/Search/Search';
import TAC from './components/Content/TAC';
import CheckOut from './components/CheckOut/CheckOut';
import CheckOutHeader from './components/CheckOut/CheckOutHeader';
import Check from './components/Private_routes/Check';
import Profile from './components/Content/Profile';
import Your_Orders from './components/Content/Your_Orders'
import Order from './components/Content/Order'
import AnnouncementBar from './components/Mainpage/AnnouncementBar';
import Wishlist from './components/Wishlist/Wishlist';
import Policy from './components/Content/Policy';
import Policies from './components/Content/Policies';
import WhatsAppIcon from './components/WhatsApp/WhatsAppIcon';
import CategoriesList from './components/Content/CategoryList';
import BestReviews from './components/Content/BestReviews';
import AllBestReviews from './components/Content/AllBestReviews';
import ScrollToTop from './components/Content/ScrollToTop';

function App() {
  const location = useLocation();
  const isCheckOutPage = location.pathname.startsWith('/check/checkout');
  return (
    <>
      <WhatsAppIcon />
      <AnnouncementBar />
      <Header />
    
      <ScrollToTop routesToScroll={['/productshow/']} />
      {isCheckOutPage && <CheckOutHeader />}
      <Routes>
        <Route path='/' element={<Landingpage />} />
        <Route path='/wishlist' element={<Wishlist />} />
        <Route path='/check/*' element={<Check />}>
          <Route path='checkoutpage' element={<CheckOut />} />
          <Route path='profile' element={<Profile />} />
          <Route path='profile/your-orders' element={<Your_Orders />} />
          <Route path='profile/your-orders/order/:order_id' element={<Order />} />
        </Route>
        <Route path='/all-best-reviews' element={<AllBestReviews />} />
        <Route path='/tac' element={<TAC />} />
        <Route path='/aboutus' element={<AboutUs />} />
        <Route path='/policy' element={<Policy />} />
        <Route path='/policies' element={<Policies />} />
        <Route path='/productshow/:product_code' element={<Productshow />} />
        <Route
          path="/productshowlike/:product_code"
          element={<Productshow key={window.location.pathname} />} // Or use a unique ID from product_code
        />
        <Route path='/allproducts' element={<Home />} />
        <Route path='/category' element={<Home />} />
        <Route path='/product' element={<Home />} />
        <Route path='/all-categories' element={<CategoryList />} />
        <Route path='/hot-products' element={<HotProducts />} />
        <Route path='/new-products' element={<NewArrival />} />
        <Route path='/also-like' element={<AlsoLike />} />
        <Route path='/best-reviews' element={<BestReviews />} />
        {/* <Route path='/shape' element={<Home />} /> */}
        <Route path='/reviewshow/:product_code' element={<Showallreviews />} />
        <Route path='/search/:query' element={<Search />} />
      </Routes>
      {!isCheckOutPage && <Footer />}
    </>
  );
}

export default App;
